import React from 'react';
import { Row, Col, Button, Input, Label, FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ProfileHeader = ({ user, isMentee, onSwitchChange, showSwitch = false, showActions = false, baseImageUrl }) => {
  return (
    <>
      <div className={`banner-img ${isMentee ? 'mentee-profile' : 'mentor-profile'}`}>
        <div className="ribbon-corner">{isMentee ? 'Mentee' : 'Mentor'}</div>

        {showSwitch && (
          <FormGroup switch className="tabs-switch">
            <Input type="switch" checked={isMentee} onClick={() => onSwitchChange(!isMentee)} />
            <Label className="mentor-label">Mentor</Label>
            <Label className="mentee-label">Mentee</Label>
          </FormGroup>
        )}
      </div>

      <Row className="profile-btn-card align-items-end mb-5">
        <Col md={8} lg={8}>
          <div className="align-items-center d-flex ms-5 image-name">
            <div className="me-4 user-avtar">
              {user && user[0]?.user && (
                <img
                  src={user[0]?.user?.imageUrl ? `${baseImageUrl}/${user[0]?.user?.imageUrl}` : `${baseImageUrl}/dummy-user.png`}
                  className="rounded-circle"
                />
              )}
            </div>
            {user && user[0]?.user && user[0]?.user.firstName && user[0]?.user.lastName && (
              <div className="user-avtar-name">
                <h2 className="mb-0">
                  {user[0]?.user?.firstName} {user[0]?.user?.lastName}
                </h2>
                <div>{user[0]?.occupation}</div>
              </div>
            )}
          </div>
        </Col>

        {showActions && (
          <Col md={4} lg={4} className="profile-btns pe-5 text-end">
            <Button tag={Link} outline id="edit-profile-btn" to={`/user-profile/${user[0]?.user.id}/edit`} replace color="primary">
              <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit Profile</span>
            </Button>

            <Button tag={Link} outline id="logout-btn" to="/logout" replace color="info" data-cy="entityDetailsBackButton">
              <FontAwesomeIcon icon="right-from-bracket" /> <span className="d-none d-md-inline">Logout</span>
            </Button>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ProfileHeader;
